import QueueList from "./components/List"

let module = "queues"

export default [
  {
    path: "queues",
    component: QueueList,
    meta: { module: module, permissions: ["queue-access"] },
  },
]
